// extracted by mini-css-extract-plugin
export var auracard = "otherCards-module--auracard--Z20ZH";
export var cardText = "otherCards-module--cardText--qFb-c";
export var cardsBlock = "otherCards-module--cardsBlock--op9oe";
export var firstCard = "otherCards-module--firstCard--lKQTC";
export var firstImage = "otherCards-module--firstImage--Pfmln";
export var otherCards = "otherCards-module--otherCards--bIUqf";
export var planetacard = "otherCards-module--planetacard--CNaBI";
export var secondBG = "otherCards-module--secondBG---S2w9";
export var secondCard = "otherCards-module--secondCard--z2Kpm";
export var secondImage = "otherCards-module--secondImage--kTD0P";